module.exports = __webpack_public_path__ + "static/img/erp1.a8c34b46.png";